/**
 * ModuleLayout - Now a simple passthrough wrapper.
 * The persistent sidebar is handled by AppLayout.
 * This component exists for backward compatibility with existing pages.
 */
export default function ModuleLayout({ children }) {
  return (
    <div className="p-4 md:p-6 lg:p-8 min-w-0 page-enter">
      {children}
    </div>
  );
}
